export default {
	page: {
		journey: {
			heading: '<span>The</span><br/><span>Journey</span> <br/> <span>So Far...</span>',
		},
		home: {
			heading: 'Welcome.',
			description: '<p>I’m Dan, a Front-end web developer living in Bristol; where you can normally find me honing my skills at the award winning <a href="https://www.craftedbygc.com" target="_blank">Green Chameleon</a>.</p><p>I have over 10 years of experience, 8 of which are concentrated on commercial work. Over the last few years, alongside other key projects, I have taken the lead on a large React app. All while dabbling with various projects and technologies in my spare time.</p><p>Thanks for stopping by.</p>',
		},
		contact: {
			heading: 'Contact.',
			description: '<p>I’m always eager to hear of new opportunities to help people.</p> <p>So If you’d like to work together, have a chat about nothing in particular or perhaps just have a random question, go ahead and ping an email to dan[at]dansnowley.com</p><p> I’d love to hear from you. 🙂</p>',
		},
		404: {
			heading: 'Page Not Found.',
			description: '<p>You seem to have stumbled upon an unknown page, perhaps try using the menu to check out existing pages?</p>',
		},
	},
};
